module.exports = __webpack_public_path__ + "static/media/fanta.a1dbdb50.jpg";